import Sidebar from "../../components/Sidebar";
import React, { useEffect, useState } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { Box, Card, CardContent, Typography, Button, Grid } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { useUser } from "../../context/userContext";


ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);

const Admin = () => {
  const navigate = useNavigate();
  const { user, setUser } = useUser();
  console.log(user);
  const [salesData, setSalesData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Sales',
        data: [],
        fill: false,
        borderColor: '#42A5F5',
        backgroundColor: '#42A5F5',
        tension: 0.4,
      },
    ],
  });

  const [barChartData, setBarChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Revenue',
        data: [],
        backgroundColor: '#66BB6A',
      },
    ],
  });

  useEffect(() => {
    // Fetch sales data from backend
    const fetchSalesData = async () => {
      try {
        const response = await fetch(`https://api.theonlysale.com/api/admin/sales?userId=${user.id}&startDate=2023-01-01&endDate=2023-12-31`);
        const data = await response.json();
        
        // Format the fetched data for the Line chart (sales overview)
        const labels = data.map(item => `Month ${item.month}`);
        const salesDataPoints = data.map(item => item.total_quantity_sold);

        setSalesData({
          labels,
          datasets: [
            {
              label: 'Sales',
              data: salesDataPoints,
              fill: false,
              borderColor: '#42A5F5',
              backgroundColor: '#42A5F5',
              tension: 0.4,
            },
          ],
        });

        // For the bar chart (Product Performance), you can modify based on product performance logic
        // This is just an example to display dynamic data
        setBarChartData({
          labels: ['Product A', 'Product B', 'Product C', 'Product D'], // Dynamic product labels
          datasets: [
            {
              label: 'Revenue',
              data: [120, 150, 80, 200], // Dummy data for now, you can fetch actual revenue data
              backgroundColor: '#66BB6A',
            },
          ],
        });
      } catch (error) {
        console.error('Error fetching sales data:', error);
      }
    };

    fetchSalesData();
  }, [user.id]);
  const accountStatus = user?.account_status;

  if (accountStatus !== 'active') {
    return (
      <Box className="p-3 min-h-screen dark:bg-gray-900 bg-gray-100" sx={{ marginLeft: { xs: 0, md: '240px' } }}>
        <Sidebar />
        <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
          <CardContent>
            <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
              Subscription Expired
            </Typography>
            <Typography className="mt-2 dark:text-gray-400 text-gray-700">
              Your subscription has expired. To access the dashboard, please renew your subscription from your profile.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2, borderRadius: '8px' }}
              href="/profile"
              className="mt-4 bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-700 dark:hover:bg-blue-800"
            >
              Go to Profile
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <>
      <Sidebar />
      <Box className="p-3 min-h-screen dark:bg-gray-900 bg-gray-100" sx={{ marginLeft: { xs: 0, md: '240px' } }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Manage Products
                </Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  sx={{ mt: 2, borderRadius: '8px' }}
                  href="/admin/product"
                  className="mt-4 bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-700 dark:hover:bg-blue-800"
                >
                  Manage Products
                </Button>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Sales Overview
                </Typography>
                <Line
                  data={salesData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: true,
                        position: 'top',
                        labels: {
                          color: 'grey',
                        },
                      },
                    },
                    scales: {
                      x: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                      y: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                    },
                  }}
                  className="mt-4"
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Product Performance
                </Typography>
                <Bar
                  data={barChartData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: true,
                        position: 'top',
                        labels: {
                          color: 'grey',
                        },
                      },
                    },
                    scales: {
                      x: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                      y: {
                        ticks: {
                          color: 'grey',
                        },
                      },
                    },
                  }}
                  className="mt-4"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Admin;
